import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import * as platform from 'platform';

@Component({
  selector: 'auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  deviceModel: any;

  constructor(private platform: Platform) { }

  ngOnInit(): void {
    this.detectDeviceModel();
  }

  detectDeviceModel() {
    const userAgent = window.navigator.userAgent;
    const info = platform.parse(userAgent);
    this.deviceModel = info.model;
  }
}
